/* CF山梨: 「チームについて」演出(Step8 v3改修版)
   - (1) .cf-reveal をスクロールに合わせて静かにフェードアップ
   - (2) ヒーロー: 見出しを1文字ずつ表示(ノーサイドHP方式)+背景パララックス
   - (3) スローガン帯: 絆ネットワーク(canvas。動く粒を細い線で結ぶ=BOND/結束。
         ポインタに粒が静かに引き寄せられ、線がつながる)+
         スローガン文字が左右から集まって1つになる演出+年のロールアップ
   - (4) 沿革(33年)の折りたたみ: 最近12年+「これ以前を見る」ボタン
   - 安全策: JSがルートに data-cf-anim を付けたときだけCSSが要素を隠す。
     文字分割や演出が失敗しても catch で即表示に倒す。
     JS無効・JSエラー・古いブラウザでは内容は常時表示(消えない)・沿革も全件表示
   - prefers-reduced-motion を尊重(演出オフ=常時表示・パララックス/canvasなし)
   - 二重初期化をガード */
(function () {
  if (window.__cfAboutFxInit) return;
  window.__cfAboutFxInit = true;

  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* 文字分割: 1文字ずつ span.cf-char に包む。英数字の連続は span.cf-word で改行禁止に。
     mask=true は各文字を overflow:hidden のセル(cf-digit)に入れる(年のロールアップ用)。
     返り値は文字spanの配列。元テキストは aria-label で保持する */
  function splitChars(el, mask) {
    var text = el.textContent;
    var chars = Array.from(text);
    var wrap = document.createElement('span');
    wrap.className = 'cf-chars';
    wrap.setAttribute('aria-hidden', 'true');
    var made = [];
    var word = null;
    for (var i = 0; i < chars.length; i++) {
      var ch = chars[i];
      var target = wrap;
      if (/[A-Za-z0-9]/.test(ch)) {
        if (!word) {
          word = document.createElement('span');
          word.className = 'cf-word';
          wrap.appendChild(word);
        }
        target = word;
      } else {
        word = null;
      }
      var s = document.createElement('span');
      s.className = 'cf-char';
      s.textContent = ch === ' ' ? ' ' : ch;
      made.push(s);
      if (mask) {
        var cell = document.createElement('span');
        cell.className = 'cf-digit';
        cell.appendChild(s);
        target.appendChild(cell);
      } else {
        target.appendChild(s);
      }
    }
    el.setAttribute('aria-label', text);
    el.textContent = '';
    el.appendChild(wrap);
    return made;
  }

  /* (1) スクロールフェードアップ */
  function setupReveal() {
    if (reduce || !hasIO) return;
    var roots = document.querySelectorAll('.cf-about, .cf-history');
    roots.forEach(function (root) {
      var items = root.querySelectorAll('.cf-reveal');
      if (!items.length) return;

      // ここで初めて隠す(以降CSSが opacity:0 を適用)。JSが確実に動く時のみ
      root.setAttribute('data-cf-anim', '');

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );

      items.forEach(function (el, i) {
        // 直近の数件だけ軽くずらして連続感を出す(過剰なstaggerはしない)
        el.style.transitionDelay = Math.min(i, 6) * 70 + 'ms';
        io.observe(el);
      });
    });
  }

  /* (2a) ヒーロー: 見出しの1文字ずつ表示(読み込み直後に発火) */
  function setupHero() {
    if (reduce || !hasIO) return;
    var about = document.querySelector('.cf-about');
    var hero = about && about.querySelector('.cf-about-statement--hero');
    if (!hero) return;
    try {
      var delay = 300; // ファーストビューの呼吸をひとつ置いてから
      var step = 55;
      hero.querySelectorAll('[data-cf-chars]').forEach(function (el) {
        var spans = splitChars(el, false);
        spans.forEach(function (s) {
          s.style.transitionDelay = delay + 'ms';
          delay += step;
        });
        delay += 200; // 行と行の間
      });
      hero.style.setProperty('--cf-body-delay', delay + 100 + 'ms');
      about.setAttribute('data-cf-anim', '');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          hero.classList.add('is-in');
        });
      });
    } catch (e) {
      hero.classList.add('is-in'); // 失敗時は即表示
    }
  }

  /* (2b) ヒーローのパララックス(背景がゆっくり追いかける) */
  function setupParallax() {
    if (reduce) return;
    var hero = document.querySelector('.cf-about-statement--hero');
    var media = hero && hero.querySelector('.cf-about-statement__media');
    if (!media) return;

    var ticking = false;
    function update() {
      ticking = false;
      // SPはパララックスなし(CSS側ものりしろなし。タッチでは効果より酔いが勝つ)
      if (window.innerWidth < 750) {
        media.style.transform = '';
        return;
      }
      var rect = hero.getBoundingClientRect();
      // ヒーローが画面内にある間だけ、スクロール量の18%で背景を追従させる
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      var shift = Math.min(Math.max(-rect.top, 0) * 0.18, rect.height * 0.16);
      media.style.transform = 'translateY(' + shift.toFixed(1) + 'px)';
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  /* (3a) スローガン帯: 文字演出(画面に入ったら発火) */
  function setupSlogan() {
    if (reduce || !hasIO) return null;
    var about = document.querySelector('.cf-about');
    var slogan = about && about.querySelector('.cf-about-slogan');
    if (!slogan) return null;
    try {
      var title = slogan.querySelector('.cf-about-slogan__title[data-cf-chars]');
      if (title) {
        // 左右に散った文字が1つに集まる(=結束)。中央から外へ少しずつ遅らせる
        var spans = splitChars(title, false);
        var mid = (spans.length - 1) / 2;
        spans.forEach(function (s, i) {
          var off = i - mid;
          s.style.setProperty('--sp', (off * 0.22).toFixed(3) + 'em');
          s.style.transitionDelay = Math.round(Math.abs(off) * 60 + 150) + 'ms';
        });
      }
      var year = slogan.querySelector('[data-cf-digits]');
      if (year) {
        // スコアボードのように1桁ずつ下から繰り上がる
        var digits = splitChars(year, true);
        digits.forEach(function (s, i) {
          s.style.transitionDelay = 250 + i * 90 + 'ms';
        });
      }
      about.setAttribute('data-cf-anim', '');
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              slogan.classList.add('is-in');
              io.disconnect();
            }
          });
        },
        { threshold: 0.3 }
      );
      io.observe(slogan);
    } catch (e) {
      slogan.classList.add('is-in'); // 失敗時は即表示
    }
    return slogan;
  }

  /* (3b) 絆ネットワーク(canvas): 漂う粒を細い線で結ぶ。ポインタも絆の一員になる */
  function setupBondNet(slogan) {
    if (!slogan || reduce || !hasIO) return;
    try {
      var canvas = document.createElement('canvas');
      canvas.className = 'cf-about-slogan__net';
      canvas.setAttribute('aria-hidden', 'true');
      slogan.insertBefore(canvas, slogan.firstChild);
      var ctx = canvas.getContext('2d');
      if (!ctx) return;

      var W = 1;
      var H = 1;
      var parts = [];
      var running = false;
      var visible = false;
      var raf = 0;
      var pointer = { x: 0, y: 0, on: false };
      var LINK = 120;

      function seed() {
        var n = Math.round(Math.min(90, Math.max(26, (W * H) / 16000)));
        parts = [];
        for (var i = 0; i < n; i++) {
          parts.push({
            x: Math.random() * W,
            y: Math.random() * H,
            vx: (Math.random() - 0.5) * 0.5,
            vy: (Math.random() - 0.5) * 0.5,
            r: 1 + Math.random() * 1.4,
          });
        }
      }
      function resize() {
        var rect = slogan.getBoundingClientRect();
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        W = Math.max(rect.width, 1);
        H = Math.max(rect.height, 1);
        canvas.width = Math.round(W * dpr);
        canvas.height = Math.round(H * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        seed();
      }
      function step() {
        raf = 0;
        ctx.clearRect(0, 0, W, H);
        var i;
        var j;
        for (i = 0; i < parts.length; i++) {
          var p = parts[i];
          if (pointer.on) {
            var dx = pointer.x - p.x;
            var dy = pointer.y - p.y;
            var d2 = dx * dx + dy * dy;
            if (d2 < 32400 && d2 > 1) {
              var d = Math.sqrt(d2);
              p.vx += (dx / d) * 0.012;
              p.vy += (dy / d) * 0.012;
            }
          }
          var sp = Math.hypot(p.vx, p.vy);
          if (sp > 0.7) {
            p.vx *= 0.7 / sp;
            p.vy *= 0.7 / sp;
          }
          p.x += p.vx;
          p.y += p.vy;
          if (p.x < -10) p.x = W + 10;
          if (p.x > W + 10) p.x = -10;
          if (p.y < -10) p.y = H + 10;
          if (p.y > H + 10) p.y = -10;
        }
        ctx.lineWidth = 1;
        for (i = 0; i < parts.length; i++) {
          for (j = i + 1; j < parts.length; j++) {
            var a = parts[i];
            var b = parts[j];
            var ddx = a.x - b.x;
            var ddy = a.y - b.y;
            if (ddx > LINK || ddx < -LINK || ddy > LINK || ddy < -LINK) continue;
            var dd = Math.hypot(ddx, ddy);
            if (dd > LINK) continue;
            ctx.strokeStyle = 'rgba(234, 242, 246, ' + ((1 - dd / LINK) * 0.3).toFixed(3) + ')';
            ctx.beginPath();
            ctx.moveTo(a.x, a.y);
            ctx.lineTo(b.x, b.y);
            ctx.stroke();
          }
          if (pointer.on) {
            var pdx = parts[i].x - pointer.x;
            var pdy = parts[i].y - pointer.y;
            var pd = Math.hypot(pdx, pdy);
            if (pd < 150) {
              ctx.strokeStyle = 'rgba(255, 255, 255, ' + ((1 - pd / 150) * 0.3).toFixed(3) + ')';
              ctx.beginPath();
              ctx.moveTo(parts[i].x, parts[i].y);
              ctx.lineTo(pointer.x, pointer.y);
              ctx.stroke();
            }
          }
        }
        ctx.fillStyle = 'rgba(255, 255, 255, 0.62)';
        for (i = 0; i < parts.length; i++) {
          ctx.beginPath();
          ctx.arc(parts[i].x, parts[i].y, parts[i].r, 0, Math.PI * 2);
          ctx.fill();
        }
        if (running) raf = requestAnimationFrame(step);
      }
      function start() {
        if (running) return;
        running = true;
        if (!raf) raf = requestAnimationFrame(step);
      }
      function stop() {
        running = false;
        if (raf) {
          cancelAnimationFrame(raf);
          raf = 0;
        }
      }

      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visible = entry.isIntersecting;
          if (visible && !document.hidden) start();
          else stop();
        });
      });
      vio.observe(slogan);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else if (visible) start();
      });
      slogan.addEventListener('pointermove', function (ev) {
        var rect = canvas.getBoundingClientRect();
        pointer.x = ev.clientX - rect.left;
        pointer.y = ev.clientY - rect.top;
        pointer.on = true;
      });
      slogan.addEventListener('pointerleave', function () {
        pointer.on = false;
      });
      window.addEventListener('resize', function () {
        resize();
      });
      resize();
    } catch (e) {
      /* 演出なしでも内容は常時表示される */
    }
  }

  /* (4) 沿革の折りたたみ(漸進的拡張: JSなしでは全件表示のまま) */
  var HISTORY_VISIBLE = 12;
  function setupHistory() {
    var list = document.querySelector('.cf-history__list');
    if (!list) return;
    var rows = list.querySelectorAll('.cf-history-row');
    if (rows.length <= HISTORY_VISIBLE + 2) return; // 数件多いだけなら折りたたまない

    list.classList.add('cf-history__list--collapsed');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cf-history__more';
    var oldest = rows[rows.length - 1].querySelector('.cf-history-row__year');
    var oldestLabel = oldest ? oldest.textContent.trim() : '';
    btn.textContent = 'これ以前の沿革を見る' + (oldestLabel ? '(' + oldestLabel + 'まで)' : '');
    btn.setAttribute('aria-expanded', 'false');

    btn.addEventListener('click', function () {
      list.classList.remove('cf-history__list--collapsed');
      btn.setAttribute('aria-expanded', 'true');
      btn.remove();
    });

    list.parentNode.insertBefore(btn, list.nextSibling);
  }

  function boot() {
    setupReveal();
    setupHero();
    setupParallax();
    var slogan = setupSlogan();
    setupBondNet(slogan);
    setupHistory();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
